/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PropertyTypesEnum {
  SingleFamily = 1,
  MultiFamily = 2,
  ApartmentComplex = 5,
  Building = 6,
  ShoppingMall = 7,
  Other = 999,
}
